// extracted by mini-css-extract-plugin
export default {"sidebar":"fqPk","sidebar-open":"Mize","sidebarOpen":"Mize","sidebar-backdrop":"C3Ke","sidebarBackdrop":"C3Ke","sidebar-minimized":"XmIA","sidebarMinimized":"XmIA"};